import { Component } from '@angular/core';
import { UserDetailsUserComponent } from 'gung-standard';

@Component({
  selector: 'cult-user-details-user',
  templateUrl: './cult-user-details-user.component.html',
  styleUrls: ['./cult-user-details-user.component.scss']
})
export class CultUserDetailsUserComponent extends UserDetailsUserComponent {
  toggleHideInvoices() {
    this.currentUser.extra.hideInvoices = !this.currentUser.extra.hideInvoices || false;
  }
}
